import React, { useEffect, useState } from 'react';

import './styles.css';

import DatePicker, { setDefaultLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import calendar from '../../../assets/images/calendar.svg';

export const InputDate = ({ cStartDate, cFinalDate, handleDate, maxIsToday, className }) => {

    const months = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
    const days = ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'];
    const today = new Date();
    const [maxFinalDate, setMaxFinalDate] = useState(new Date());
    const locale = {
        localize: {
            month: n => months[n],
            day: n => days[n]
        },
        formatLong: {}
    }
    const validateDate = (sDate, fDate) => {
        let finalDate = new Date(sDate);
        finalDate = finalDate.setMonth(finalDate.getMonth() + 3);
        setMaxFinalDate(finalDate);

        handleDate(sDate, fDate);
    }

    return (
        <div className={`box-date-filter ${className ?? ''}`}><img src={calendar} />
            <DatePicker popperPlacement="bottom-start" className="date-filter" dateFormat="dd/MM/yyyy" maxDate={today} selected={cStartDate} onChange={(value) => validateDate(value, cFinalDate)} locale={locale} />
            <span>a</span>
            <DatePicker popperPlacement="bottom-end" className="date-filter" dateFormat="dd/MM/yyyy" maxDate={maxIsToday ? today : maxFinalDate} minDate={cStartDate} selected={cFinalDate} onChange={(value) => validateDate(cStartDate, value)} locale={locale} />
        </div>
    );
}

export default InputDate;